import * as types from './mutation-types'

export default {
  [types.SET_POS] (state, data) {
    state.POs = data
  },

  [types.SET_TOTAL_POS] (state, totalEstimates) {
    state.totalPOs = totalEstimates
  },

  [types.ADD_PO] (state, data) {
    state.POs = [...state.estimates, data]
  },

  [types.DELETE_PO] (state, id) {
    let index = state.POs.findIndex(PO => PO.id === id)
    state.POs.splice(index, 1)
  },

  [types.SET_SELECTED_POS] (state, data) {
    state.selectedPOs = data
  },

  [types.DELETE_MULTIPLE_POS] (state, selectedPOs) {
    selectedPOs.forEach((PO) => {
      let index = state.POs.findIndex(_est => _est.id === PO.id)
      state.POs.splice(index, 1)
    })

    state.selectedPOs = []
  },

  [types.UPDATE_PO] (state, data) {
    let pos = state.POs.findIndex(estimate => estimate.id === data.estimate.id)

    state.POs[pos] = data.estimate
  },

  [types.UPDATE_PO_STATUS] (state, data) {
    let pos = state.POs.findIndex(estimate => estimate.id === data.id)

    if (state.POs[pos]) {
      state.POs[pos].status = data.status
    }
  },

  [types.RESET_SELECTED_POS] (state, data) {
    state.selectedPOs = []
    state.selectAllField = false
  },

  [types.SET_TEMPLATE_ID] (state, templateId) {
    state.purchaseOrderTemplateId = templateId
  },

  [types.SELECT_SUPPLIER] (state, data) {
    state.selectedSupplier = data
  },

  [types.RESET_SELECTED_SUPPLIER] (state, data) {
    state.selectedSupplier = null
  },

  [types.SET_SELECT_ALL_STATE] (state, data) {
    state.selectAllField = data
  },
  [types.SET_PO_FOR_DELIVERYNOTES] (state, data) {
    state.POForDeliveryNotes = data
  },
  [types.SET_PO_FOR_INVOICES] (state, data){
    state.POForInvoices = data
  },
  [types.RESET_PO_FOR_INVOICES](state, data) {
    state.POForInvoices = null
  },
}
